module.exports = __webpack_public_path__ + "static/icon-rate.bdc93b0a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-rate.png
// module id = 986
// module chunks = 2